import { Stack } from '@mui/system';
import Pill from '../../../../../components/Pill';
import { WHY_CHOOSE_NIRVA } from '../../constants';
import {
  SectionWrapper,
  GridContainer,
  ImageContainer,
  ImageFrame,
  StyledImage,
  SectionTitle,
  pillStyles,
} from './styles';

const WhyChooseNirvaSection = () => {
  return (
    <SectionWrapper>
      <GridContainer>
        <ImageContainer>
          <ImageFrame elevation={0}>
            <StyledImage
              component="img"
              alt={WHY_CHOOSE_NIRVA.imageAlt}
              src={WHY_CHOOSE_NIRVA.image}
            />
          </ImageFrame>
        </ImageContainer>

        <Stack spacing={2.25}>
          <SectionTitle>{WHY_CHOOSE_NIRVA.title}</SectionTitle>

          <Stack spacing={1.25}>
            {WHY_CHOOSE_NIRVA.reasons.map((reason, index) => (
              <Pill key={index} sx={pillStyles}>
                {reason}
              </Pill>
            ))}
          </Stack>
        </Stack>
      </GridContainer>
    </SectionWrapper>
  );
};

export default WhyChooseNirvaSection;
